// extracted by mini-css-extract-plugin
export default {"YesButtonComponentStyling":"YesNoButtons_YesButtonComponentStyling__QTQ7s","NoButtonComponentStyling":"YesNoButtons_NoButtonComponentStyling__q4T5e"};